<div [outerHTML]="employmentDurationLabel"></div>
